import { AfterViewInit, Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import {
  RegistrationStepService,
  RegistrationStepQuery,
  LoggingService,
  ErrorStateService,
  StepType,
  ProviderTranslation,
  ProviderName,
} from '@fgb/core';
import { TmLoginButtonComponent } from '../login-providers/tm-login-button/tm-login-button.component';

@Component({
  selector: 'fgbcl-registration-provider-oauth',
  templateUrl: './registration-provider-oauth.component.html',
  styleUrls: ['./registration-provider-oauth.component.scss'],
})
export class RegistrationProviderOauthComponent implements OnInit, AfterViewInit {
  readonly stepType = StepType.ProviderOAuth;
  customer: ProviderTranslation = {} as ProviderTranslation;
  hasAccountDetails: boolean = false;
  externalRefNumber: string = '';
  @ViewChild('providerLogin', { read: ViewContainerRef }) vc: ViewContainerRef;

  constructor(
    private registrationStepQuery: RegistrationStepQuery,
    private registrationStepService: RegistrationStepService,
    private logService: LoggingService,
    public errorService: ErrorStateService,
    private router: Router,
    private resolver: ComponentFactoryResolver
  ) {
    this.externalRefNumber = this.router?.lastSuccessfulNavigation?.extras?.state?.AccountNumber;
  }

  ngOnInit(): void {
    const step = this.registrationStepQuery.getStep(this.stepType);

    if (!step) {
      this.logService.warning('No step data found in the store for step', this.stepType);
      return;
    }

    if (step.Data != null && step.Data.ExternalRefNumber !== '' && step.Data.ExternalRefNumber != null) {
      this.customer.ExternalRefNumber = step.Data.ExternalRefNumber;
      this.customer.EmailAddress = step.Data.EmailAddress;
      this.hasAccountDetails = true;
    } else if (this.externalRefNumber !== '') {
      this.customer.ExternalRefNumber = this.externalRefNumber;
      this.hasAccountDetails = true;
    }
  }

  ngAfterViewInit(): void {
    this._init();
  }

  private _init(): void {
    const step = this.registrationStepQuery.getStep(this.stepType);
    const providerId = +(step?.Settings as any)?.ProviderId;
    const component = this._getProviderComponent(providerId);

    if (component) {
      const factory = this.resolver.resolveComponentFactory(component);
      const componentRef = this.vc.createComponent(factory);
      componentRef.changeDetectorRef.detectChanges();
    }
  }

  /**
   * Get login component based on provider id provided
   */
  private _getProviderComponent(providerId: number) {
    switch (providerId) {
      case ProviderName.TicketMaster:
      case ProviderName.TicketMasterUK:
        return TmLoginButtonComponent;
      default:
        return null;
    }
  }

  public submitStep(): void {
    this.registrationStepService.submitRegistrationStepData(this.stepType, this.customer).toPromise();
  }
}
